import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function TableauComparatif() {
  const { t } = useTranslation('toiture');
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal<HTMLDivElement>(0.15);
  const { ref: tableRef, isVisible: tableVisible } = useScrollReveal<HTMLDivElement>(0.1);

  const rows = [
    {
      type: t('tableau_bardeau_type'),
      duree: t('tableau_bardeau_duree'),
      prix: t('tableau_bardeau_prix'),
      entretien: t('tableau_bardeau_entretien'),
      ideal: t('tableau_bardeau_ideal'),
    },
    {
      type: t('tableau_tole_type'),
      duree: t('tableau_tole_duree'),
      prix: t('tableau_tole_prix'),
      entretien: t('tableau_tole_entretien'),
      ideal: t('tableau_tole_ideal'),
    },
    {
      type: t('tableau_membrane_type'),
      duree: t('tableau_membrane_duree'),
      prix: t('tableau_membrane_prix'),
      entretien: t('tableau_membrane_entretien'),
      ideal: t('tableau_membrane_ideal'),
    },
    {
      type: t('tableau_blanc_type'),
      duree: t('tableau_blanc_duree'),
      prix: t('tableau_blanc_prix'),
      entretien: t('tableau_blanc_entretien'),
      ideal: t('tableau_blanc_ideal'),
    },
  ];

  return (
    <section id="tableau" className="bg-white py-20 md:py-28 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Title */}
        <div
          ref={titleRef}
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <h2
            className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-4"
            dangerouslySetInnerHTML={{ __html: t('tableau_h2') }}
          />
        </div>

        {/* Table */}
        <div
          ref={tableRef}
          className={`transition-all duration-1000 delay-200 ${
            tableVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Desktop Table */}
          <div className="hidden md:block overflow-hidden rounded-lg border border-soft-dark">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-slate-primary">
                  <th className="px-6 py-4 text-white font-semibold text-sm w-[20%]">{t('tableau_col_type')}</th>
                  <th className="px-6 py-4 text-white font-semibold text-sm w-[18%]">{t('tableau_col_duree')}</th>
                  <th className="px-6 py-4 text-white font-semibold text-sm w-[22%]">{t('tableau_col_prix')}</th>
                  <th className="px-6 py-4 text-white font-semibold text-sm w-[20%]">{t('tableau_col_entretien')}</th>
                  <th className="px-6 py-4 text-white font-semibold text-sm w-[20%]">{t('tableau_col_ideal')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={idx} className={`${idx % 2 === 0 ? 'bg-white' : 'bg-soft-gray'} hover:bg-copper/5 transition-colors`}>
                    <td className="px-6 py-4 text-slate-primary font-semibold text-sm">{row.type}</td>
                    <td className="px-6 py-4 text-gray-500 text-sm">{row.duree}</td>
                    <td className="px-6 py-4 text-copper font-semibold text-sm">{row.prix}</td>
                    <td className="px-6 py-4 text-gray-500 text-sm">{row.entretien}</td>
                    <td className="px-6 py-4 text-gray-500 text-sm">{row.ideal}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {rows.map((row, idx) => (
              <div key={idx} className="bg-soft-gray rounded-lg p-5">
                <h4 className="font-manrope font-bold text-slate-primary text-base mb-3">{row.type}</h4>
                <div className="space-y-2">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">{t('tableau_col_duree')}</span>
                    <span className="text-slate-primary font-medium">{row.duree}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">{t('tableau_col_prix')}</span>
                    <span className="text-copper font-semibold">{row.prix}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">{t('tableau_col_entretien')}</span>
                    <span className="text-slate-primary">{row.entretien}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">{t('tableau_col_ideal')}</span>
                    <span className="text-slate-primary">{row.ideal}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <p className="text-gray-400 text-sm text-center mt-6">
            {t('tableau_note')}
          </p>
        </div>
      </div>
    </section>
  );
}